import React, { useContext } from "react";
import { ConstantsContext } from "shared/context/ConstantsContext";
import { Modal } from "react-bootstrap";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { filterBy } from '@progress/kendo-data-query';
import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";

export default function TestFile(props) {
  const { oktaAuth } = useOktaAuth();

  const allData = [
    { id: 1, text: 'Small' },
    { id: 2, text: 'Medium' },
    { id: 3, text: 'Large' }
  ];

  const [data, setData] = React.useState(allData.slice());
  const [state, setState] = React.useState({});

  const handleChange = (event) => {
    setState({
      value: event.target.value
    });
  };

  const filterData = filter => {
    const data = allData.slice();
    return filterBy(data, filter);
  };
  const filterChange = event => {
    console.log(event);
    setData(filterData(event.filter));
  };

  function showTheSelectedValue() {
    console.log(state);
  }

  function makeApiCall() {
    let accessToken = oktaAuth.getAccessToken();

    let response = axios.get(`api/UserProgram/TestUpdateDashboard`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });

    console.log(response);
  };

  // return (
  // <div>
  //   <div>T-shirt size:</div>
  //   <DropDownList
  //   data={data}
  //   textField="text"
  //   value={state.value}
  //   onChange={handleChange}
  //   filterable={true}
  //   onFilterChange={filterChange}
  //   style={{
  //     width: '300px'
  //   }} />
  //   <button onClick={showTheSelectedValue}>Click Me</button>
  // </div>);

  return (
    <div>
      <button onClick={makeApiCall}>Click Me</button>
    </div>
  );
};
